// 统一请求路径前缀在libs/axios.js中修改
import {getRequest, postRequest, putRequest, deleteRequest, uploadFileRequest} from '@/libs/axios';


// 添加
export const addHr = (params) => {
    return postRequest('/base/user/addhr', params)
}

// 修改
export const editHr = (params) => {
    return postRequest('/base/user/edithr', params)
}
// 删除
export const delHrByIds = (ids) => {
    return postRequest("/base/user/delHrByIds", {
        ids: ids
    })
}

// 列表
export const hrList = (params) => {
    return postRequest('/base/user/hrlist', params)
}

// 获取单个对象
export const getHr = (id) => {
    return getRequest(`/base/user/get/${id}`)
}

// 黑名单
export const blacklistList = (params) => {
    return postRequest('/base/blacklist/blacklistList', params)
}